/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const idealWeightTime = useStore((state) => state.idealWeightTime);
  const setIdealWeightTime = useStore((state) => state.setIdealWeightTime);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.idealWeightTime.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={idealWeightTime}
          onChange={(value) => {
            setIdealWeightTime(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'ideal-weight-time',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'lessThanYear'}>
            <span>📅</span> {t('onboarding.idealWeightTime.options.lessThanYear')}
          </Option>
          <Option value={'oneTwoYears'}>
            <span>🗓️</span> {t('onboarding.idealWeightTime.options.oneTwoYears')}
          </Option>
          <Option value={'moreThanThree'}>
            <span>⏳</span> {t('onboarding.idealWeightTime.options.moreThanThree')}
          </Option>
          <Option value={'never'}>
            <span>❌</span> {t('onboarding.idealWeightTime.options.never')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
